<tran-application-detail-dashboard-box [heading]="heading()">
    @if (!readonly()) {
        <div class="card-body space-y-4">
            <si-file-dropzone
                [accept]="fileUploaderConfig.accept"
                [maxFileSize]="fileUploaderConfig.maxFileSizeInBytes"
                [multiple]="true"
                (filesAdded)="onFilesAdded($event)"
            />

            @if (selectedFiles().length > 0) {
                <div class="flex flex-col gap-4">
                    <div class="flex flex-col gap-2 border border-gray-300 rounded-lg p-4 space-y-2">
                        @for (file of selectedFiles(); track file.file) {
                            <tran-upload-file-item [attachment]="file" (delete)="removeAddedFile($event)" />
                        }
                    </div>
                    <div class="flex justify-end items-center mb-3">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            [title]="
                                'components.application-detail-dashboard.application-detail-attachments.clear'
                                    | translate
                            "
                            [ariaLabel]="
                                'components.application-detail-dashboard.application-detail-attachments.clear'
                                    | translate
                            "
                            (click)="clearAllAddedFiles()"
                        >
                            {{
                                'components.application-detail-dashboard.application-detail-attachments.clear'
                                    | translate
                            }}
                        </button>
                    </div>
                </div>
            }
        </div>
    }

    @if (isLoading()) {
        <div class="flex justify-center items-center h-32">
            <si-loading-spinner />
        </div>
    } @else if (!attachments().length) {
        <div class="flex flex-row w-full justify-center">
            <span class="text-secondary">
                {{ noAttachmentsDisclaimer() | translate }}
            </span>
        </div>
    } @else {
        <tran-file-list
            [attachments]="attachments()"
            [hasMoreAttachments]="hasMoreAttachments()"
            [allowDelete]="!readonly()"
            [allowUndoDelete]="!readonly()"
            [askDelete]="false"
            (loadMore)="loadMore.emit()"
            (download)="download.emit($event)"
            (delete)="addFileToDelete($event)"
            (undoDelete)="removeFileFromDelete($event)"
        />
    }
</tran-application-detail-dashboard-box>
